// src/data/marketSketchData.js

const marketNewsList = [
  {
    id: 1,
    title:
      "Canadian banks a ‘very good place’ for investors to be amid tariff threats: portfolio manager",
    author: "BNN Bloomberg",
    date: "26 Feb 2025",
    content: `
      <p><strong>By Daniel Johnson</strong></p>

      <p>The Canadian banking sector could be a good option for investors navigating 
      tariff uncertainty, one portfolio manager says, as the Big Six lenders report earnings this week.</p>

      <p><strong>Bank of Montreal</strong> and <strong>Bank of Nova Scotia</strong> released first-quarter earnings 
      on Tuesday, kicking off earnings season, with both lenders beating analysts’ estimates, 
      according to Bloomberg News.</p>

      <blockquote>
        “If you want to be anywhere in the Canadian market in the present uncertainties, 
        the banks are a very good place to be,” said Gavin Graham, CIO and portfolio manager at Spire Wealth Management.
      </blockquote>

      <h3>U.S. Operations as a Hedge</h3>
      <p>Graham added that <strong>Bank of Montreal</strong>, <strong>Toronto-Dominion Bank</strong>, 
      and <strong>Royal Bank of Canada</strong> in particular have strong U.S. operations that could act 
      as a hedge against tariff uncertainty.</p>

      <p>“Secondly, if we are going to see a refocus on domestic business, on breaking down interprovincial barriers, 
      on reallocating the focus of the Canadian exports away from an exclusive focus on the U.S. 
      towards other markets, that’s obviously got to be good news for the banks,” Graham said.</p>

      <h3>Peak Loan Loss Provisions</h3>
      <p>BMO and Scotiabank both cited the possible impact of tariffs on loan performance. 
      BMO set aside <strong>$152 million</strong> in provisions for performing loans, while Scotiabank 
      set aside <strong>$98 million</strong>.</p>

      <p>In total, Scotiabank’s provisions for credit losses (PCLs) totaled <strong>$1.16 billion</strong>, 
      higher than the <strong>$1.09 billion</strong> forecasted by analysts. BMO’s PCLs totaled <strong>$1.01 billion</strong>, 
      less than the <strong>$1.08 billion</strong> forecasted by analysts.</p>

      <blockquote>
        “I think the banks are erring on the side of being conservative, but yes you’d have to feel 
        that this is probably, if not the peak quarter, then next quarter,” said Graham.
      </blockquote>

      <h3>Conclusion</h3>
      <p>Despite tariff concerns, Canada’s large banks remain in a strong competitive position 
      due to their robust capital positions and consistent dividend payouts.</p>

      <p>For more details, visit the original article at 
      <a href="https://www.bnnbloomberg.ca/investing/2025/02/25/canadian-banks-a-very-good-place-for-investors-to-be-amid-tariff-threats-portfolio-manager/" target="_blank">
      BNN Bloomberg</a>.</p>
    `,
  },
  {
    id: 2,
    title: "Gold prices surge to record high as economic uncertainty grows",
    author: "BNN Bloomberg",
    date: "24 Feb 2025",
    content: `
      <p><strong>By Max Smirnov</strong></p>

      <p>The price of gold has surged to <strong>CAD$4,200 per ounce</strong>, a sharp rise from about <strong>CAD$2,800</strong> a year ago, 
      as demand for the precious metal reaches unprecedented levels.</p>

      <blockquote>
        “In uncertain time periods, gold has always been a safe haven,” said Max Smirnov, 
        owner of Global Bullion Suppliers in Toronto.
      </blockquote>

      <h3>Economic Uncertainty Fuels Demand</h3>
      <p>Experts attribute the rising price of gold to global instability. The re-election of U.S. 
      President <strong>Donald Trump</strong>, trade tensions, and conflicts in Ukraine and the Middle East 
      have driven investors towards gold as a hedge against uncertainty.</p>

      <p>Additionally, central banks have increased gold purchases to protect against inflation.</p>

      <blockquote>
        “People often cling to gold in times of crisis,” said William Huggins, assistant professor of 
        finance at the DeGroote School of Business.
      </blockquote>

      <h3>Tariff Concerns and Market Volatility</h3>
      <p>Tariff concerns continue to affect investor sentiment.</p>
      <p>“The idea with tariffs is that they’re going to create a lot of economic difficulties in Canada,” 
      said Huggins. “And at the moment, people don’t really know what the impact of them will be.”</p>

      <h3>Jewelry Prices Soar</h3>
      <p>Jewelry prices have also skyrocketed. Allen Ash, from Muzeum’s jewelry division, noted that 
      a <strong>10-karat gold bracelet</strong> that previously cost <strong>$3,900</strong> now sells for around <strong>$10,300</strong>, 
      more than double its pre-pandemic price.</p>

      <h3>More Record Highs Ahead?</h3>
      <p>This week, analysts at <strong>Goldman Sachs</strong> predicted that gold could reach 
      <strong>US$3,100 per ounce (CAD$4,400)</strong> by year’s end, with the possibility of hitting 
      <strong>US$3,300</strong> if trade tensions persist.</p>

      <blockquote>
        “There’s an argument to be made that it’s the perfect time to sell because it’s at an all-time high,” 
        Smirnov said. “But on the flip side, it could go even higher.”
      </blockquote>

      <h3>The Long-Term Value of Gold</h3>
      <p>Despite potential volatility, Smirnov believes that gold will always hold value.</p>

      <blockquote>
        “It might go up, it might go down, but it’s never going to be worthless. 
        And that’s why it’s lasted throughout history.”
      </blockquote>

      <p>For more details, visit the original article at 
      <a href="https://www.bnnbloomberg.ca/markets/gold/2025/02/23/gold-prices-surge-to-record-high-as-economic-uncertainty-grows/" target="_blank">
      BNN Bloomberg</a>.</p>
    `,
  },
  {
    id: 3,
    title: "S&P/TSX composite down more than 100 points, U.S. stocks also fall",
    author: "BNN Bloomberg",
    date: "21 Feb 2025",
    content: `
      <p><strong>TORONTO — Canada’s main stock index lost more than 100 points Thursday, 
      weighed down by losses in technology and industrials, while U.S. stock markets also fell.</strong></p>

      <p>The <strong>S&P/TSX composite index</strong> closed down <strong>112.08 points</strong> at <strong>25,514.08</strong>.</p>

      <p>In New York, the <strong>Dow Jones industrial average</strong> fell <strong>450.94 points</strong> at <strong>44,176.65</strong>. 
      The <strong>S&P 500</strong> index dropped <strong>26.63 points</strong> to <strong>6,117.52</strong>, while the 
      <strong>Nasdaq composite</strong> fell <strong>93.89 points</strong> to <strong>19,962.36</strong>.</p>

      <h3>Walmart Earnings Drive Market Movements</h3>
      <p>The primary driver of the market downturn Thursday was the earnings report from retail giant 
      <strong>Walmart</strong>, said <strong>Hadiza Djataou</strong>, vice-president and portfolio manager at 
      Mackenzie Investments.</p>

      <p>While Walmart reported strong sales and profit, its projections for <strong>2025</strong> disappointed investors 
      as inflation and potential tariffs weigh on consumer sentiment. Shares in Walmart fell <strong>6.5%</strong> Thursday.</p>

      <h3>Retail and Bank Stocks Also Decline</h3>
      <p>Concern over lower consumer spending saw other retail and bank stocks fall, including:</p>
      <ul>
        <li><strong>Costco:</strong> down <strong>2.6%</strong></li>
        <li><strong>Target:</strong> down <strong>2.0%</strong></li>
        <li><strong>Amazon:</strong> down <strong>1.7%</strong></li>
      </ul>

      <blockquote>
        “Between the targeted tariffs on Canada and Mexico, the universal tariffs, and all that coming is leading 
        the consumer to be more cautious about spending habits,” Djataou said.
      </blockquote>

      <h3>Interest Rate Cut Expectations Shift</h3>
      <p>Despite generally strong earnings reports, recent inflation data has come in hotter than expected, 
      raising doubts about <strong>interest rate cuts</strong>. Tariffs are widely considered inflationary, adding to 
      concerns over monetary policy.</p>

      <p>In the U.S., expectations for rate cuts by the <strong>Federal Reserve</strong> have been scaled back. 
      In contrast, Canada’s economy has been hit harder by higher interest rates, making rate cuts more likely.</p>

      <h3>Canadian Dollar Strengthens Slightly</h3>
      <p>The Canadian dollar traded for <strong>70.48 cents US</strong>, up from <strong>70.31 cents US</strong> on Wednesday.</p>

      <h3>Commodities Market Update</h3>
      <ul>
        <li><strong>Crude oil:</strong> up <strong>38 cents</strong> at <strong>US$72.48 per barrel</strong></li>
        <li><strong>Natural gas:</strong> down <strong>13 cents</strong> at <strong>US$4.15 per mmBTU</strong></li>
        <li><strong>Gold:</strong> up <strong>US$20</strong> at <strong>US$2,956.10 per ounce</strong></li>
        <li><strong>Copper:</strong> up <strong>5 cents</strong> at <strong>US$4.61 per pound</strong></li>
      </ul>

      <p>For more details, visit the original article at 
      <a href="https://www.bnnbloomberg.ca/markets/2025/02/20/sptsx-composite-down-more-than-100-points-us-stocks-also-fall/" target="_blank">
      BNN Bloomberg</a>.</p>
    `,
  },
];

export default marketNewsList;
